module.exports = __webpack_public_path__ + "img/trinity_link_silos.cbdb13c5.png";